import './Page.scss'
import { AppLink } from '../Link'
import { Panel } from '../Panel'
import { QuickLink } from '../QuickLink'
import { QuickLinksFragment } from '../QuickLink/QuickLink.generated'
import { Filters } from '../Filters'
import { useHierarchicalFilterContext } from '@/contexts/HierarchicalFilterContext/HierarchicalFilterContext'
import HierarchicalFilter from '../HierarchicalFilter/HierarchicalFilter'
import { DocumentErrorRegular, FilterFilled, FilterRegular } from '@fluentui/react-icons'
import { usePageFilters } from '@/contexts/PageFilterContext/PageFilterContextProvider2'
import { usePage } from '@/contexts/PageProvider/PageProvider'
import clsx from 'clsx'
import { InteractPane } from '../InteractPane'
import { Tooltip } from '@fluentui/react-components'

export function Page() {
  const { page } = usePage()
  const {
    primaryPageFilters,
    pageFilters,
    updatePrimaryPageFilters,
    selectClear,
    multiSelect,
    multiSelectAll,
    multiClearAll,
  } = usePageFilters()
  const { hierarchicalFilters } = useHierarchicalFilterContext()
  console.log('hierarchicalFilters', hierarchicalFilters)

  const hasFilters = primaryPageFilters?.length || pageFilters?.length || hierarchicalFilters?.length

  if (!page) {
    return (
      <div className="flex size-full items-center justify-center bg-grey-lightest">
        <div className="flex flex-col items-center justify-center gap-y-8">
          <DocumentErrorRegular fontSize={72} className="text-grey-medium" />
          <div className="flex items-center gap-x-2">
            <span>Page not available</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="grid h-[calc(100vh-86px)] w-full grid-cols-[1fr_auto]">
      <div
        className={clsx('ux-page box-border !h-[calc(100vh-86px)]')}
        style={{ backgroundImage: `url("${page.background?.imageUrl}")` }}
      >
        <aside className={clsx({ topbar: hasFilters })}>
          {hierarchicalFilters && hierarchicalFilters.length > 0 && (
            <div className="hierarchical-filter-panel">
              {hierarchicalFilters.map((filter) => (
                <HierarchicalFilter key={filter.id} {...filter} />
              ))}
            </div>
          )}
          <div className="flex flex-1 items-center justify-end gap-x-10">
            {primaryPageFilters && primaryPageFilters?.length > 0 && (
              <Filters
                topbarFilter={true}
                filters={primaryPageFilters ?? []}
                updateFilters={updatePrimaryPageFilters}
                primaryFilters={true}
                selectClear={selectClear}
                multiSelect={multiSelect}
                multiClearAll={multiClearAll}
                multiSelectAll={multiSelectAll}
              />
            )}
            {!!pageFilters?.length && (
              <div>
                <AppLink
                  toggleParams={[
                    {
                      key: 'interact',
                      value: 'filters',
                      __typename: 'Param',
                    },
                  ]}
                  __typename="NavLink"
                >
                  <Tooltip content="Show page filters panel" relationship="label">
                    <div className="flex size-8 items-center justify-center justify-self-end text-grey-medium hover:border-primary hover:text-primary">
                      <FilterFilled fontSize={30} />
                    </div>
                  </Tooltip>
                </AppLink>
              </div>
            )}
          </div>
        </aside>
        <div className="scrollable-context">
          <div className="page-content">
            <div>
              {page.banner && (
                <div className="banner-wrapper">
                  {page.banner.title && <div className="banner-title">{page.banner.title}</div>}
                  {page.banner.subtitle && <div className="banner-subtitle">{page.banner.subtitle}</div>}
                </div>
              )}
              {page?.title ? (
                <div className="title-wrapper">
                  <div className="title">{page.title}</div>
                </div>
              ) : (
                <div></div>
              )}
              {page.link && (
                <div className="page-link">
                  <AppLink {...page.link}>{page.link.label}</AppLink>
                </div>
              )}
            </div>
            <div className="panels">
              {page?.panels?.map((panel, panelIdx) => <Panel key={`panel-${panelIdx}`} {...panel} />)}
            </div>
            {/* TODO @RM - rework page layout for this empty div */}
            <div></div>
            <div>{page.quickLinks?.links && <QuickLinks {...page.quickLinks} />}</div>
          </div>
        </div>
      </div>
      <InteractPane />
    </div>
  )
}

function QuickLinks(props: QuickLinksFragment) {
  if (!props.links) {
    return <></>
  }
  // TODO use radix scroll-area. Adds keyboard, accessibility, scrollbar, etc
  return (
    <div className="ux-quick-links">
      {props.links.map((ql) => (
        // TODO what is the correct 'key' to use here?
        <QuickLink key={ql.title} {...ql} />
      ))}
    </div>
  )
}
